import defaultSettings from '@/settings'

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  tagsView: tagsView,
  sidebarLogo: sidebarLogo
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

const getters = {
  tagsViewGetter (state, getters, rootState, rootGetters){
    return state.tagsView;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}




// WEBPACK FOOTER //
// ./src/store/modules/settings.js